const KEY = 'rl_block';

/** Called by the tab that hit a 429. Other open tabs hear this via the storage event. */
export function signalRateLimit(reason: string, retryAfterSeconds: number) {
  localStorage.setItem(
    KEY,
    JSON.stringify({ reason, until: Date.now() + retryAfterSeconds * 1000 })
  );
}

export function getActiveRateLimitSignal(): { reason: string } | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const { reason, until } = JSON.parse(raw) as { reason: string; until: number };
    if (until > Date.now()) return { reason };
    localStorage.removeItem(KEY);
    return null;
  } catch {
    return null;
  }
}
